import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@mui/material';
import { ADD_BUTTON_SIZE } from '../../_constants/styleConst';

type AddButtonProps = {
  onClick: () => void;
};

/** 画面右下に固定される追加ボタン */
const AddButton: React.FC<AddButtonProps> = ({ onClick }) => {
  return (
    <Fab
      color="primary"
      aria-label="add"
      sx={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: ADD_BUTTON_SIZE,
        height: ADD_BUTTON_SIZE,
      }}
      onClick={onClick}
    >
      <AddIcon sx={{ fontSize: `calc(${ADD_BUTTON_SIZE} / 2)` }} />
    </Fab>
  );
};

export default AddButton;
